import { Connection } from './connection';
import { CoordinatorService } from './coordinator.service';
import { XItem } from './x-item';

export type PFPARAMS = {
    connection: Connection | string;
    f?: File;
    payload?: any;
    rawText?: string;
};

export class ParserFile {
    isFinal = false;
    errorMessage = '';
    warningMessage = '';

    private _cacheLs: ParserFile[] = [];

    id: string;
    private _specialId?: string;
    connection?: Connection;

    localFile?: File;
    rawText?: string;
    payload?: any;

    xitemLs?: XItem[];

    suggestName = '';

    constructor(
        private coords: CoordinatorService,
        params: PFPARAMS,
    ) {
        this.id = this.coords.uniqueId();

        if (params.connection instanceof Connection) this.connection = params.connection;
        else this._specialId = params.connection;

        this.localFile = params.f;
        this.rawText = params.rawText;
        this.payload = params.payload;

        this.connection && this.connection.registerParserFile(this);
    }

    async parse(cacheLs: ParserFile[] = []) {
        this._cacheLs = cacheLs;
        if (this.localFile) {
            await this.coords.script$.system$.parseFile(this);
        } else if (this.rawText) {
            this.coords.worker$.parser.directPost({
                action: 'load-text',
                payload: {
                    parserFileId: this.id,
                    rawText: this.rawText,
                },
            });
        } else if (this.payload) {
            console.log(`Calling parser worker with payload input and parserFileId: ${this.id}`);
            this.coords.worker$.parser.directPost({
                action: 'load-payload',
                payload: {
                    parserFileId: this.id,
                    input: this.payload,
                },
            });
        }
    }

    submitXItems(xitemLs: XItem[]) {
        this.xitemLs = xitemLs;
        this._finalize();
        this.connection && this.connection.parserFileResult();
    }

    response(params: any) {
        if (this._cacheLs.length) {
            this._cacheLs.pop()?.parse(this._cacheLs);
            this._cacheLs = [];
        }
        // console.log("PF response", params.meta, params.payload)
        this.suggestName = params.meta?.suggestName || this.suggestName;
        this.warningMessage = params.meta?.warning || '';
        switch (params.meta?.type) {
            case 'xitem-list':
                this.xitemLs = [];
                let ls = params.payload;
                if (!Array.isArray(ls)) ls = params.payload?.data || params.payload?.items || [];
                ls.forEach((xi: any) => this.xitemLs!.push(new XItem(this.coords, xi)));

                // if (!params.error)
                this._finalize();
                this.connection && this.connection.parserFileResult();
                break;
        }
    }

    error(txt: string) {
        this.errorMessage = txt;
        this.connection?.refreshMessageWidget('error', this.errorMessage);
        this._finalize();
        this.connection && this.connection.parserFileResult();
    }

    private _finalize() {
        this.isFinal = true;
        this.rawText = '';
    }
}
